import Vue from 'vue';
import { Component, Prop, Provide } from 'vue-property-decorator';
import tmsService from '../../services/axios/tmsService';
import clientService from '../../services/axios/axiosService';
import qs from 'qs';
import switchBillingToService from '../../shared/switchBillingToService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
// Components
import template from './savedQuote.vue';
import DefaultModal from '../../components/modal';
import MessageModal from '../../components/messageModel';

@Component({
    mixins: [template],
    components: {
        DefaultModal,
        MessageModal,
    },
})
export default class SavedQuote extends Vue {
    // Data
    savedQuoteData: any = null;
    activeRadio: number = -1;
    quoteSelected: boolean = false;
    pendingDeleteQuote: any = {
        key: 0,
        quoteId: '',
    };
    bill_to_id: number = 0;
    active_quote_id: number = 0;
    active_quote_amount: number = 0;
    active_billto_id: number = 0;
    // Data

    isLoading = false;

    // life cycle methods
    created() {
        this.getCustomerData();
    }

    mounted() {}
    // end of life cycle methods

    pagination = {
        min: 1,
        max: 10,
        totalOrders: 0,
        totalPaginationCount: 0,
        paginationLink: {},
        paginationSet: {},
        currentPaginationIndex: 0,
        paginationStart: 0,
        paginationEnd: 5,
        hide: false,
    };

    updatePaginationModel(paginationIndex: any) {
        this.pagination.currentPaginationIndex = paginationIndex;
        this.pagination.min = this.pagination.paginationSet[paginationIndex].min;
        this.pagination.max = this.pagination.paginationSet[paginationIndex].max;

        console.log('min: ' + this.pagination.min + ', max: ' + this.pagination.max);

        this.updatePaginationLink(paginationIndex);

        console.log('total pagination count: ' + this.pagination.totalPaginationCount);
        console.log('current pagination: ' + this.pagination.currentPaginationIndex);
    }

    incrementPagination() {
        if (this.pagination.currentPaginationIndex + 1 <= this.pagination.totalPaginationCount) {
            this.pagination.currentPaginationIndex++;
            this.updatePaginationModel(this.pagination.currentPaginationIndex);
        }
    }

    decrementPagination() {
        if (this.pagination.currentPaginationIndex - 1 >= 0) {
            this.pagination.currentPaginationIndex--;
            this.updatePaginationModel(this.pagination.currentPaginationIndex);
        }
    }

    updatePaginationLink(paginationIndex: any) {
        let limiter: number = 4;
        let offset: number = 2;
        let link: object[] = [];

        paginationIndex += 1;

        if (paginationIndex >= limiter) {
            let start: number = paginationIndex - offset;
            let end: number = paginationIndex + offset;

            this.pagination.paginationStart = start;
            this.pagination.paginationEnd = end;

            for (let i: number = start; i <= end - 1; i++) {
                link.push({
                    value: i,
                    index: i - 1,
                });
                if (i == this.pagination.totalPaginationCount) {
                    break;
                }
            }
        } else {
            for (let i: number = 1; i <= this.pagination.totalPaginationCount; i++) {
                if (i <= limiter) {
                    link.push({
                        value: i,
                        index: i - 1,
                    });
                } else {
                    break;
                }
            }
        }

        console.log(link);
        this.pagination.paginationLink = link;
    }

    generatePaginationObject(totalRows: number) {
        // Each pagination has 10 rows each.
        let group: number = Math.floor(totalRows / 10);
        // Fetch any mod remainder from total rows.
        let end: number = totalRows % 10;
        let min: number = 1;
        let max: number = 10;
        let pagiObject: object[] = [];

        console.log('total rows: ' + totalRows);
        console.log('group: ' + group);
        console.log('end: ' + end);

        // If total rows has a mod remainder, add an extra pagination value to accomodate extra rows.
        if (end > 0) {
            group += 1;
        }

        this.pagination.totalPaginationCount = group;

        for (let i: number = 1; i <= group; i++) {
            console.log('i: ' + i);
            console.log('min: ' + min + ', max: ' + max);
            if (i == group) {
                if (end > 0) {
                    max = min + end - 1;
                }

                this.pagination.totalOrders = max;

                console.log('-> ' + i);
                console.log('min: ' + min + ', max: ' + max);
            }

            pagiObject.push({
                min: min,
                max: max,
            });

            min += 10;
            max += 10;
        }

        console.log(pagiObject);

        this.pagination.paginationSet = pagiObject;
        this.updatePaginationLink(0);
    }

    // methods
    async getCustomerData() {
        this.isLoading = true;

        switchBillingToService
            .post()
            .then((res: any) => {
                if (res.data.billing == null) {
                    this.isLoading = false;
                } else {
                    this.bill_to_id = res.data.billing.location_id;
                    this.getQuote();
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    async getQuote() {
        let url1 = 'write_new/get_tms_quote_line.php';

        let json3 = {
            input_search_quote_id: null,
            input_search_date_from: null,
            input_search_date_to: null,
            billto_id: this.bill_to_id,
            input_search_shipper_state: '0',
            input_search_shipper_zip: null,
            input_search_consignee_state: '0',
            input_search_consignee_zip: null,
            input_search_status: 1,
            input_search_limit: 50,
            quote: 1,
            UserID: localStorage.UserID,
            UserToken: localStorage.UserToken,
        };

        console.log('BILLTO_ID:' + this.bill_to_id);

        tmsService
            .post(url1, qs.stringify(json3))
            .then(res => {
                this.isLoading = false;
                console.log(res);

                // remove the ones have order id
                this.savedQuoteData = res.data.filter((item: any) => {
                    return !item.fk_tms_order_id;
                });

                if (this.savedQuoteData.length > 0) {
                    if (this.savedQuoteData.length <= 10) {
                        this.pagination.hide = true;
                    } else {
                        this.generatePaginationObject(this.savedQuoteData.length);
                    }
                } else {
                    this.pagination.hide = true;
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    setActiveRadio(key: number, item: any) {
        this.active_quote_amount = item.total_amount;
        this.active_billto_id = item.fk_billto_id;
        // this.active_quote_id = item.tms_quote_id;

        let radio = document.getElementById(`radio${key}`) as HTMLInputElement;

        if (radio.checked) {
            this.activeRadio = -1;
            this.quoteSelected = false;

            setTimeout(() => {
                radio.checked = false;
            }, 1);
        } else {
            this.activeRadio = key;
            this.quoteSelected = true;
        }
    }

    goToEdit(key: number) {
        let quoteId = this.savedQuoteData[key].tms_quote_id;
        let quoteFrom = this.savedQuoteData[key].tms_quote_from;
        let type: string = '';
        if (quoteFrom == 'LAST_MILE_SERVICE') {
            type = 'lastmile';
        } else {
            type = 'truckload';
        }
        this.$router.push({
            name: 'Quote',
            query: {
                isEdit: 'true',
                quoteType: type,
                quoteNumber: quoteId,
            },
        });
    }

    async getCreditLimit(billto_id: number, quote_amount: number) {
        try {
            let bill_to = { billto_id: billto_id, current_amount: quote_amount };
            let response = await clientService.post('write/get_credit_limit_balance.php', bill_to);
            let creditLimit = response.data;

            if (creditLimit == -1) {
                // this.$modal.show(this.errorOverCreditModal);
            } else if (creditLimit == -2) {
                // this.$modal.show(this.errorNoCreditModal);
            } else if (creditLimit == 1) {
                // this.keepQuote = true;
                // this.savedQuote();
                this.$store.dispatch('changeQuotePageStage', 'schedulePage');
                window.location.href = '#/schedulepickup';
            }
        } catch (error) {
            console.log(error.message);
        }

        // console.log("response: " + this.creditLimit);
    }

    goToSchedule() {
        let quoteId = this.savedQuoteData[this.activeRadio].tms_quote_id;
        let quoteFrom = this.savedQuoteData[this.activeRadio].tms_quote_from;
        console.log('go to schedule:::', quoteId);
        this.$router.push({
            name: 'ScheduleApickup',
            params: {
                quoteId: quoteId,
            },
        });
    }

    goToScheduleKey(key: number) {
        let quoteId = this.savedQuoteData[key].tms_quote_id;
        let quoteFrom = this.savedQuoteData[key].tms_quote_from;
        if (quoteFrom == 'LAST_MILE_SERVICE') {
            window.location.href = `#/lastMileQuote?schedule=true&quoteNumber=${quoteId}`;
        } else {
            window.location.href = `#/unis100Quote?schedule=true&quoteNumber=${quoteId}`;
        }
        // window.location.href = `#/getquote?schedule=true&quoteNumber=${quoteId}`;
    }

    async deleteQuote(key: number, quoteId: string) {
        this.pendingDeleteQuote.key = key;
        this.pendingDeleteQuote.quoteId = quoteId;
        this.$modal.show(this.deleteModal);
    }

    // modal
    deleteModal: string = 'deleteModal';
    async rightBtnDeleteModal() {
        try {
            let response = await tmsService.post('write_new/write_tms_quote_decline.php', {
                quote_id: this.pendingDeleteQuote.quoteId,
            });
            if (response.data == 1) {
                this.savedQuoteData.splice(this.pendingDeleteQuote.key, 1);
            } else {
                throw new Error('delete failed');
            }
        } catch (error) {
            this.$modal.show(this.errorMessage);
            console.log(error.message);
        } finally {
            this.$modal.hide(this.deleteModal);
        }
    }
    leftBtnDeleteModal() {
        this.$modal.hide(this.deleteModal);
    }
    // modal

    // error Message
    errorMessage: string = 'errorMessage';
    // error Message
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/savedQuote/index.ts